import { Box, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { CostCenterAssignment } from 'modules/cost_centers/components/CostCenterAssigments/lib/types'

import { Options } from './Options'
import { AssignationsTag, Tag } from './Tag'

interface Options {
  onEdit?: () => void
  onDelete?: () => void
}

interface Props {
  assignments: CostCenterAssignment[]
  options?: Options
}

export const AssignmentList = ({ assignments, options }: Props) => {
  const startDate = moment(assignments[0]?.startDate).format('ll')
  const endDate = assignments[0]?.endDate ? moment(assignments[0]?.endDate).format('ll') : null

  return (
    <>
      <Box flexDirection="row" alignItems="flexStart" justifyContent="spaceBetween">
        <Box flexDirection="row" gap="s8" paddingBottom="s20">
          <Text.Normal weight="medium" size="300" color="grey1000">
            {startDate} {endDate ? ` - ${endDate}` : ''}
          </Text.Normal>

          <AssignationsTag
            startDate={String(assignments[0]?.startDate)}
            endDate={assignments[0]?.endDate}
          />
        </Box>

        {options && <Options onEdit={options.onEdit} onDelete={options.onDelete} />}
      </Box>

      <Box gap="s6">
        {assignments.map((cc) => (
          <Box key={cc.id} flexDirection="row" justifyContent="spaceBetween" alignItems="center">
            <Text.Normal size="200" color="textSecondary">
              {cc.costCenter.code
                ? `${cc.costCenter.code} - ${cc.costCenter.name}`
                : cc.costCenter.name}
            </Text.Normal>

            <Tag text={`${(cc.percentage * 100).toFixed(2)}%`} background="grey400" />
          </Box>
        ))}
      </Box>
    </>
  )
}
